import defaultTheme from "../defaultTheme"
import paywellTheme from "../paywellTheme"
import eshandiTheme from "../eshandiTheme"
import circuPayTheme from "../circuPayTheme"

const themeSelector = (companyName: string) => {
  switch (companyName) {
    case "circupay":
      return circuPayTheme
    default:
      return defaultTheme
  }
}

export default themeSelector
